// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

// export default function DropDownFilterTags({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   Height,
//   OverFlow,
//   minheight,
//   placeholder = "",
//   marginLeft,
//   marginTop,
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState("");
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   const handleClick = (option) => {
//     setSelected(option);
//     setIsActive(false);
//     setSelectedLabel(option.label);
//   };

//   useEffect(() => {
//     const selectedOption = options.find((opt) => opt.id === selected);
//     if (selectedOption) {
//       setSelectedLabel(selectedOption.label);
//     } else {
//       setSelectedLabel("");
//     }
//   }, [selected, options]);
  

//   return (
//     <div className="dropdown" style={{ width, marginLeft, marginTop}} ref={dropdownRef}>
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}>
//         {/* {selectedLabel} */}
//         {selectedLabel || placeholder}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {/* {isActive && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             maxHeight: minheight,
//             height: Height,
//             overflow: OverFlow,
//           }}
//         >
//           {options.map((option) => (
//             <div
//               key={option.id}
//               className="dropdown-item"
//               onClick={() => handleClick(option)}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )} */}
//         {isActive && (
//           <div
//             className="dropdown-content"
//             style={{
//               width: customWidth,
//               top: customTop,
//               maxHeight: minheight,
//               height: Height,
//               overflow: OverFlow,
//             }}
//           >
//             <div
//               className="dropdown-item"
//               onClick={() => handleClick({ id: null, label: "" })}
//               // style={{ color: "red", fontStyle: "italic" }}
//             >
//               Select
//             </div>

//             {options.map((option) => (
//               <div
//                 key={option.id}
//                 className="dropdown-item"
//                 onClick={() => handleClick(option)}
//               >
//                 {option.label}
//               </div>
//             ))}
//           </div>
//         )}
//     </div>
//   );
// }













import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function DropDownFilterTags({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
  placeholder = "",
  marginLeft,
  marginTop,
  disabled = false, // ✅ Add disabled prop
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleClick = (option) => {
    if (disabled) return; // ✅ Prevent action if disabled
    setSelected(option);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  useEffect(() => {
    const selectedOption = options.find((opt) => opt.id === selected);
    if (selectedOption) {
      setSelectedLabel(selectedOption.label);
    } else {
      setSelectedLabel("");
    }
  }, [selected, options]);

  return (
    <div
      className={`dropdown ${disabled ? "disabled-dropdown" : ""}`}
      style={{ width, marginLeft, marginTop }}
      ref={dropdownRef}
    >
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div
        className={`dropdown-btn ${disabled ? "disabled" : ""}`}
        style={{ opacity: disabled ? 0.6 : 1, }}
        onClick={() => {
          if (!disabled) setIsActive(!isActive);
        }}
      >
        {selectedLabel || placeholder}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>

      {isActive && !disabled && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: minheight,
            height: Height,
            overflow: OverFlow,
          }}
        >
          <div
            className="dropdown-item"
            onClick={() => handleClick({ id: null, label: "" })}
          >
            Select
          </div>
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
